<template>
  <v-toolbar flat fixed dark class="topNavbar" data-test="top-navbar">
    <v-toolbar-title>
      <CSCareshipLogo class="logo" />
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <CSButton
      id="navbar-help-btn"
      icon
      flat
      v-if="!hideHelp"
      :iconClass="isHelpOpen ? 'topNavbar__helpIcon--active' : ''"
      data-test="info-sidenav-btn"
      @click="isHelpOpen ? $emit('drawer:close') : $emit('drawer:openHelp')"
      iconName="help-circle"
    />

    <CSButton
      id="navbar-menu-btn"
      icon
      flat
      v-if="!isSideNavOpen"
      data-test="open-sidenav-btn"
      @click="$emit('drawer:openNav')"
      iconName="menu"
    />

    <CSButton
      id="navbar-close-btn"
      icon
      flat
      v-else
      data-test="close-sidenav-btn"
      @click="$emit('drawer:close')"
      iconName="cross"
    />
  </v-toolbar>
</template>

<script>
import CSButton from '@/components/atoms/button/CSButton.vue'
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'
import CSCareshipLogo from '@/components/atoms/logo/CSCareshipLogo.vue'

export default {
  name: 'TopNavbar',

  components: {
    CSCareshipLogo,
    CSSVGIcon,
    CSButton,
  },

  props: {
    isSideNavOpen: {
      type: Boolean,
    },

    isHelpOpen: {
      type: Boolean,
    },

    hideHelp: {
      type: Boolean,
    },
  },
}
</script>
